import React, { useEffect, useState } from "react";
import axios from "./axios";
import "./row.css";
import YouTube from "react-youtube";
import movieTrailer from "movie-trailer";

const baseurl = "https://image.tmdb.org/t/p/original/";

const Row = (props) => {
  const [movies, setmovies] = useState([]);
  const [trailerUrl, setTrailerurl] = useState("");

  useEffect(() => {
    async function fetchData() {
      const request = await axios.get(props.fetchUrl);
      setmovies(request.data.results);
      // console.log(request.data.results)
      // return request;
    }
    fetchData();
  }, [props.fetchUrl]);

  const opts = {
    height: "390",
    weight: "100%",
    playerVars: {
      autoplay: 1
    }
  };

  const handleClick = (movie) => {
    if (trailerUrl) {
      setTrailerurl("");
    } else {
      movieTrailer(movie?.name || "")
        .then((url) => {
          const urlParams = new URLSearchParams(new URL(url).search);
          setTrailerurl(urlParams.get("v"));
        })
        .catch((err) => console.log(err));
    }
  };

  console.table(movies);
  return (
    <div className="row">
      <h2 style={{ color: "white" }}>{props.title}</h2>
      <div className="row-posters">
        {movies.map((movie) => (
          <img
            key={movie.id}
            onClick={() => handleClick(movie)}
            className={`row-poster ${props.isLargeRow && "row-posterLarge"}`}
            src={` ${baseurl}${
              props.isLargeRow ? movie.poster_path : movie.backdrop_path
            }
            `}
            alt={movie.name}
          />
        ))}
      </div>
      {trailerUrl && <YouTube videoId={trailerUrl} opts={opts} />}
    </div>
  );
};

export default Row;
